import { Paper, Stack, Tab, Tabs, Typography } from "@mui/material";
import CustomTabPanel from "components/atoms/CustomTabPanel";
import React from "react";
import { useThemeCtx } from "store/contextStore/theme/ThemeStore";
import Temperature from "./Temperature";
import BMI from "./BMI";
import BloodPressure from "./BloodPressure";
import RespirationRate from "./RespirationRate";
import HeartRate from "./HeartRate";
import GlucoseLevel from "./GlucoseLevel";
import OxygenSaturation from "./OxygenSaturation";

const navItems = [
  {
    label: "Temperature",
    id: 0,
    component: <Temperature />,
  },
  {
    label: "Body Mass Index (BMI)",
    id: 1,
    component: <BMI />,
  },
  {
    label: "Blood Pressure",
    id: 2,
    component: <BloodPressure />,
  },
  {
    label: "Respiration Rate",
    id: 3,
    component: <RespirationRate />,
  },
  {
    label: "Heart Rate",
    id: 4,
    component: <HeartRate />,
  },
  {
    label: "Glucose Level",
    id: 5,
    component: <GlucoseLevel />,
  },
  {
    label: "Oxygen Saturation",
    id: 6,
    component: <OxygenSaturation />,
  },
];

function VitalSignsGraph() {
  const { state } = useThemeCtx();
  const [value, setValue] = React.useState(0);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <Paper sx={{ p: 2, minHeight: "70vh" }}>
      <Stack spacing={1} my={2}>
        <hgroup>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", fontSize: "18px" }}
          >
            Vital signs
          </Typography>
          <Typography sx={{ fontSize: "14px", opacity: 0.7 }}>
            Key health measurements recorded during patient visits.
          </Typography>
        </hgroup>
      </Stack>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="nav tabs example"
        variant="scrollable"
        scrollButtons={"auto"}
        allowScrollButtonsMobile
        indicatorColor="secondary"
        sx={{
          overflow: "hidden !important",

          "& .MuiTabs-indicator": {
            bgcolor: state.lightTheme ? "black" : "white",
          },
          "& .MuiTab-root.Mui-selected": {
            color: "text.primary",
          },
        }}
      >
        {navItems.map((item) => (
          <Tab
            key={item.id}
            component="a"
            onClick={(event) => {
              event.preventDefault();
              setValue(item.id);
            }}
            label={item.label}
          />
        ))}
      </Tabs>
      {navItems.map((nav) => (
        <CustomTabPanel key={nav.label} value={value} index={nav.id}>
          {nav.component}
        </CustomTabPanel>
      ))}
    </Paper>
  );
}

export default VitalSignsGraph;
